/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Divider, Modal, Row } from 'antd';
import { deleteFinancialStageItem } from '../../data/store/account/accountActions';

const DeleteStageItem = ({modalDeleteItem, handleDeleteClose, stageId, itemType}) => {
  const { t } = useTranslation('');
  const dispatch = useDispatch();

  const { financialPlan } = useSelector((state) => state.accountReducer);

  const getItemById = useMemo(() => {
    const itemStage = financialPlan?.stages?.find( i => i.id === +stageId);
    const item = itemStage?.[itemType]?.find(i => i.id === modalDeleteItem);
    return item;
  }, [modalDeleteItem, stageId, financialPlan, itemType]);

  const handleDelete = () => {
    dispatch(deleteFinancialStageItem({stageId, itemId: modalDeleteItem, itemType, callback: handleDeleteClose}));
  };

  return (
    <Modal
        width={700}
        className="modal-content-paper item"
        open={modalDeleteItem}
        onCancel={handleDeleteClose}
        destroyOnClose
        footer={null}
        zIndex={1600}>
        <Row justify="start">
          <Col className="modal-title">{t('MODAL_DELETE_TITLE')}</Col>
        </Row>
        <Divider className='modal-divider'/>
        <Row justify="start" className="modal-text-wrapper">
          <Col>
            <p className="modal-description">{t('MODAL_DELETE_ITEM')}</p>
            <p className="modal-name">{getItemById?.name}</p>
          </Col>
        </Row>
        <Row justify="end" style={{marginTop: '50px'}}>
          <Col>
            <Button
              className="modal-action-btn cancel-btn"
              onClick={handleDeleteClose}
            >
              {t('CANCEL')}
            </Button>
            <Button 
              style={{marginLeft: '8px'}}
              className="modal-action-btn delete-btn" 
              onClick={handleDelete}>
              {t('DELETE')}
            </Button>
          </Col>
        </Row>
      </Modal>
  );
};

export default DeleteStageItem;

DeleteStageItem.propTypes = {
  stageId: PropTypes.string,
  itemType: PropTypes.string,
  modalDeleteItem: PropTypes.string,
  handleDeleteClose: PropTypes.func,
};
